'use strict'

import React from 'react'

function ProductPrice (props) {
  return (
    <div className="price-block">
      <div className="price-box">
        {
          props.hasOwnProperty('OLD_PRICE') ?
            <div className="price-old">
              <span>{props.PRINT_OLD_PRICE}</span>
            </div> :
            <></>
        }
        <div className="price">
          <span>{props.PRINT_PRICE}</span>
        </div>
      </div>
      <div className="price-usd">{props.PRINT_PRICE_USD}</div>
    </div>
  )
}

export default ProductPrice